import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, Clock, Hash } from 'lucide-react';
import { DriverDetails } from '@/types/driver.types';
import { format } from 'date-fns';
import { ar } from 'date-fns/locale';

interface DriverMetadataProps {
  driver: DriverDetails;
}

export function DriverMetadata({ driver }: DriverMetadataProps) {
  const formatDate = (dateString: string) => {
    try {
      return format(new Date(dateString), 'dd MMMM yyyy', { locale: ar });
    } catch {
      return '-';
    }
  };

  const formatTime = (dateString: string) => {
    try {
      return format(new Date(dateString), 'HH:mm', { locale: ar });
    } catch {
      return '-';
    }
  };

  const metadata = [
    {
      icon: Calendar,
      label: 'تاريخ الإنشاء',
      value: formatDate(driver.created_at),
      subValue: formatTime(driver.created_at),
    },
    {
      icon: Clock,
      label: 'آخر تحديث',
      value: formatDate(driver.updated_at),
      subValue: formatTime(driver.updated_at),
    },
    {
      icon: Hash,
      label: 'معرّف الناقل',
      value: driver.carrier_user_id?.slice(0, 8) + '...',
      fullValue: driver.carrier_user_id,
      isCode: true,
    },
  ];

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold flex items-center gap-2">
          <Clock className="h-4 w-4" />
          البيانات الوصفية
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {metadata.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.label} className="flex items-center gap-3">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-muted">
                  <Icon className="h-3.5 w-3.5 text-muted-foreground" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-muted-foreground">{item.label}</p>
                  <p className={`text-sm font-medium ${item.isCode ? 'font-mono text-xs' : ''}`} dir={item.isCode ? 'ltr' : 'rtl'}>
                    {item.value}
                    {item.subValue && (
                      <span className="text-muted-foreground ms-2">({item.subValue})</span>
                    )}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
